// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2IgNG","list":"styles_list__3wQoK"};